module.exports = __webpack_public_path__ + "static/media/Art1.77cd438e.pdf";